var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v("固定商户码 / 门店码"),
                  ]),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 长期有效，贴在收银台即可。用户扫码后自行输入金额，"
                    ),
                    _c("b", [_vm._v("需要你在「核销台」二次确认")]),
                    _vm._v("才会扣积分。 "),
                  ]),
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店 ID" } },
                        [
                          _c("el-input-number", {
                            staticClass: "numWidth",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: _vm.storeId,
                              callback: function ($$v) {
                                _vm.storeId = $$v
                              },
                              expression: "storeId",
                            },
                          }),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v("留 0 表示整店通用的商户码"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.staticLoading,
                              },
                              on: { click: _vm.loadStaticCode },
                            },
                            [_vm._v("生成")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.staticCode
                    ? _c(
                        "div",
                        { staticClass: "code-box" },
                        [
                          _c("div", { ref: "staticQr", staticClass: "qr" }),
                          _c("div", { staticClass: "code-text" }, [
                            _vm._v(_vm._s(_vm.staticCode)),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.copy(_vm.staticCode)
                                },
                              },
                            },
                            [_vm._v("复制码内容")]
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "empty" }, [_vm._v("尚未生成")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v("动态订单码"),
                  ]),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 指定订单号与金额生成，" +
                        _vm._s(_vm.ttl) +
                        " 秒后过期。用户扫完直接核销，不需要你再确认， 适合收银时一单一码。 "
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "dynamicForm",
                      attrs: {
                        model: _vm.dynamicForm,
                        rules: _vm.dynamicRules,
                        "label-width": "90px",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单号", prop: "bizNo" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: { maxlength: "64" },
                            model: {
                              value: _vm.dynamicForm.bizNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dynamicForm,
                                  "bizNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "dynamicForm.bizNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单金额", prop: "amountYuan" } },
                        [
                          _c("el-input-number", {
                            staticClass: "selWidth",
                            attrs: { min: 0.01, precision: 2 },
                            model: {
                              value: _vm.dynamicForm.amountYuan,
                              callback: function ($$v) {
                                _vm.$set(_vm.dynamicForm, "amountYuan", $$v)
                              },
                              expression: "dynamicForm.amountYuan",
                            },
                          }),
                          _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店 ID" } },
                        [
                          _c("el-input-number", {
                            staticClass: "numWidth",
                            attrs: { min: 0, controls: false },
                            model: {
                              value: _vm.dynamicForm.storeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.dynamicForm, "storeId", $$v)
                              },
                              expression: "dynamicForm.storeId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.dynamicLoading,
                              },
                              on: { click: _vm.submitDynamic },
                            },
                            [_vm._v("生成")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.dynamicCode
                    ? _c("div", { staticClass: "code-box" }, [
                        _c("div", { ref: "dynamicQr", staticClass: "qr" }),
                        _c("div", { staticClass: "code-text" }, [
                          _vm._v(_vm._s(_vm.dynamicCode.codeToken)),
                        ]),
                        _c(
                          "div",
                          {
                            class: [
                              "countdown",
                              _vm.countdown > 0 ? "" : "expired",
                            ],
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.countdown > 0
                                    ? _vm.countdown + " 秒后过期"
                                    : "已过期，请重新生成"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }